module.exports = __webpack_public_path__ + "img/home-cover-1.1155c2ab.png";